
import React, {
  useCallback,
  useEffect,
  useState
} from 'react';
import { IProps } from "./types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@material-ui/core';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import style from './style.module.scss';

const NS = 'StaffNameDialog';

export default function StaffNameDialog({
  dataTestId,
  isOpen = false,
  confirmText,
  rejectText,
  title,
  description,
  children,
  handleConfirm,
  handleReject,
  diffInfoList
}: IProps) {

  const [staffname, setStaffName] = useState<string>("");
  const [staffError, setStaffError] = useState<boolean>(false);

  useEffect(() => {
    isOpen && setStaffError(false);
  }, [isOpen])

  const handleConfirmClick = useCallback(() => {
    if (!staffname) {
      setStaffError(() => true);
    } else {
      handleConfirm(staffname);
    }
  }, [staffname])

  return (
    <Dialog
      data-testid={dataTestId}
      open={isOpen}
      onClose={handleReject}
      aria-labelledby="simple-dialog-title"
      aria-describedby="simple-dialog-description"
    >
      <DialogTitle id="simple-dialog-title" disableTypography={true} className={style.dialogBox}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="simple-dialog-description" className={style.description}>
          <span dangerouslySetInnerHTML={{__html:description}} />
        </DialogContentText>
        {
          diffInfoList && (
            <table className={style.removeBorder}>
              {diffInfoList.map((info, index) => {
                return(
                  <tr key={index}>
                    <td>{info.key}:</td>
                    <td>{info.original}</td>
                    <td>
                      <span><ArrowRightAltIcon /></span>
                    </td>
                    <td>{info.new}</td>
                  </tr>
                )

              })}
            </table>
          )
        }
        <TextField
          name='staffName'
          type="text"
          label="Staff name"
          required
          helperText="Please enter Staff name"
          onChange={(evt) => {
            const hasStaffError = !evt.currentTarget.value;
            setStaffError(hasStaffError);
            setStaffName(evt.currentTarget.value);
          }}
          error={staffError}
        />
      </DialogContent>
      {children}
      <DialogActions>
        <Button onClick={() => {
          setStaffName('');
          handleReject();
        }} color="default">
          {rejectText}
        </Button>
        <Button
          onClick={handleConfirmClick}
          color="primary"
          autoFocus
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

